module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "modal"
  }, [_c('transition', {
    attrs: {
      "name": "modal-transition"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "modal__wrap",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal__container",
    class: {
      'modal__container--image': _vm.component == 'ImageContainer'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation()
      }
    }
  }, [_c('div', {
    staticClass: "modal__content-wrap scrollable"
  }, [_c('a', {
    staticClass: "modal__button-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close($event)
      }
    }
  }, [_vm._v("x")]), _c('div', {
    staticClass: "modal__content"
  }, [_vm._t("default", [_c(_vm.component, _vm._b({
    ref: "content",
    tag: "component",
    attrs: {
      "inModal": true
    },
    on: {
      "close": _vm.close
    }
  }, 'component', _vm.data, false))])], 2)]), _c('div', {
    staticClass: "modal__footer",
    attrs: {
      "id": "modal__footer"
    }
  })])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79caa3c6","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Modal.vue
// module id = Owjm
// module chunks = 0 1